import React from 'react'
import Link from 'gatsby-link'

import {Collab, Hero, Nav} from '../components/letterhead'

const Logos = () => (
  <div className="logos"
    style={{
      paddingBottom: '100px'
    }}
  >
    <div className="icon-react"></div>
    <div className="icon-gatsby"></div>
    <div className="icon-sass"></div>
  </div>
)

const IndexPage = () => (
  <div>
    <Nav />
    <Collab />
    <div className="container">
      <h1>Details</h1>
      <Logos />
      <p>
        I reached out to Caitlin M. on the Parse.ly team when I decided to
        apply, to see if she had any tips on how to stand out and how to best
        show that I'm a great fit for the team. Per her advice to highlight my
        experience working remotely, and my experience with modern Javascript
        frameworks (she mentioned Angular and Vue specifically), I thought it'd
        be fun to put together this quick project to make a stronger impression
        than the usual cover letter and resume combo.
      </p>
      <p>
        This static site is built with React and <a href="http://gatsbyjs.org">Gatsby</a>, with a small Sass file for
        styles.
      </p>
      <a href="https://www.netlify.com">
        <img src="https://www.netlify.com/img/global/badges/netlify-dark.svg" />
      </a>
      <p>
        <Link to="/" className="has-arrow-before">
          go back.
        </Link>
      </p>
    </div>
  </div>
);

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/details.js